module.exports = __webpack_public_path__ + "app-static/img/12.077df431.png";